export const APP_CONTAINER_CLASSNAME = 'app-container';
export const APP_CONTAINER_SELECTOR = `.${APP_CONTAINER_CLASSNAME}`;
